<div class="subheader" style="margin-bottom: 1rem;">
  Reviews
</div>

<div class="rating-card" *ngIf="combinedRating !== null && hasBadges" style="background-color: #f9f9f9; padding: 20px; border-radius: 10px;">
  <div class="rating-container">
    <div class="rating-row">
      <span class="rating-number">{{ combinedRating | number: '1.1-1' }}</span>
      <div class="stars">
        <span class="rating-description">{{ ratingDescription }}</span>
        <div class="stars-row">
          <!-- Dynamically render stars -->
          <img *ngFor="let star of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; let i = index"
               src="assets/icons/star_rating.svg" 
               [class.filled]="i < roundedCombinedRating"
               alt="Star" />
        </div>
      </div>
    </div>
    <div class="review-count">
      <img src="assets/icons/chat.svg" alt="Review Count" />
      <ng-container i18n>
        {{ combinedReviewCount }} reviews
      </ng-container>
    </div>
  </div>
</div>
<app-votes [hostel]="hostel" [overallRating]="combinedRating" [totalReviews]="combinedReviewCount"></app-votes>
<div class="comments">
  <app-comment *ngFor="let review of top4Reviews" [review]="review"></app-comment>
</div>

<!--<button [@fadeIn] class="btn btn-raised theme" style="max-width: 175px;">-->
<!--  <span>View All Reviews</span>-->
<!--</button>-->
